import { useState } from "react";
import { toast } from "sonner";
import { ArrowRight } from "lucide-react";
import { api, formatError } from "@/lib/api";

export const NewsletterForm = ({ prefix = "newsletter", compact = false }) => {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/newsletter", { email });
      toast.success(data.already ? "Sei già iscritto alla newsletter!" : "Iscrizione completata! Ti avviseremo alle prossime uscite.");
      setEmail("");
    } catch (err) { toast.error(formatError(err)); }
    finally { setBusy(false); }
  };
  return (
    <form onSubmit={submit} className={`flex w-full ${compact ? "max-w-sm" : "max-w-lg"} border border-white/15 rounded-full p-1 focus-within:border-emerald-500/60 transition-colors`} data-testid={`${prefix}-form`}>
      <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="La tua email"
        className="flex-1 min-w-0 bg-transparent px-4 text-sm outline-none placeholder:text-zinc-500" data-testid={`${prefix}-email-input`} />
      <button disabled={busy} className="inline-flex items-center gap-2 rounded-full bg-emerald-500 text-black px-5 py-2.5 text-sm font-semibold hover:bg-emerald-400 disabled:opacity-60 transition-colors" data-testid={`${prefix}-submit-btn`}>
        {busy ? "…" : "Iscriviti"} <ArrowRight className="h-4 w-4" />
      </button>
    </form>
  );
};

export const NewsletterSection = () => (
  <section className="max-w-7xl mx-auto px-5 sm:px-8 py-20" data-testid="newsletter-section">
    <div className="relative overflow-hidden border border-emerald-500/30 bg-[#0d0e12] p-8 sm:p-14 grid md:grid-cols-[1.2fr_1fr] gap-8 items-center">
      <div className="absolute -right-24 -bottom-24 h-72 w-72 rounded-full vinyl-grooves vinyl-spin opacity-40" />
      <div className="relative">
        <p className="font-mono-tga text-xs uppercase tracking-[0.3em] text-emerald-400">Newsletter</p>
        <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-black uppercase tracking-tight mt-3">Non perderti la prossima anomalia</h2>
        <p className="text-sm sm:text-base text-zinc-400 mt-3">Lascia la tua email: ti avvisiamo quando esce un nuovo brano.</p>
      </div>
      <div className="relative"><NewsletterForm prefix="home-newsletter" /></div>
    </div>
  </section>
);
